import React from 'react';
import c from 'classnames';
import UserLink from '../../../User/Link';
import s from './AuthorUserLink.scss';
/** A styled version of our user link. Looks different based on a couple PapiComment booleans (e.g. a featured variant). */ const AuthorUserLink = ({ comment , className  })=>{
    const { user , isAuthorHighlited , isFeatured  } = comment;
    return /*#__PURE__*/ React.createElement(UserLink, {
        withTooltip: true,
        user: user,
        className: c(s['root'], isAuthorHighlited && s['highlight'], isFeatured && s['featured'], className),
        relatedItemBiData: {
            typeid: comment.typeId,
            itemid: comment.itemId
        }
    });
};
AuthorUserLink.displayName = 'AuthorUserLink';
export default AuthorUserLink;
